import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { FormacionIcon } from "../../Icons/CollaboratorsIcons";
import {
  employeeExperienceTranslate,
  wheelCollaboratorTranslate,
} from "../../i18n/translatedMessages";
import EducationAccordion from "./Components/EducationComponent/EducationAccordion";
import {
  getCandidateFormationValues,
  postCandidateEducation,
} from "../../API/Candidates/Education";
import Loading from "../../Components/Loading/Loading";
import { AiOutlinePlusCircle } from "react-icons/ai";

const InfoEducacion = () => {
  const objEmpty = {
    name: null,
    entry_date: "2000-01-01",
    university: null,
    diploma_url: null,
    departure_date: "En curso",
    formation_level_id: "1",
  };

  const [dataEducations, setDataEducations] = useState([objEmpty]);
  const [dataKnowledges, setDataKnowledges] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [updateActiveItem, setUpdateActiveItem] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function getEducationCandidate() {
      const data = await getCandidateFormationValues(localStorage.getItem("candidateId"));
      if (data.items.formacions != null) {
        setDataKnowledges(data);
        setDataEducations(data.items.formacions);
        setActiveItem((parseInt(data.items.formacions.length) - 1).toString());
        setIsLoading(false);
      } else {
        setDataEducations([objEmpty]);
        setIsLoading(false);
      }
    }
    getEducationCandidate();
  }, []);

  const handleChange = (event) => {
    setUpdateActiveItem(true);
    const { name, value } = event.target;

    setDataEducations((prevData) => {
      const newData = [...prevData];
      const index = event.target.getAttribute("data-index");
      newData[index][name] = value;
      setActiveItem(event.target.getAttribute("data-index"));
      return newData;
    });
  };

  const handleAdd = () => {
    setDataEducations((prevData) => [...prevData, objEmpty]);
    setActiveItem(parseInt(dataEducations.length).toString());
  };

  useEffect(() => {
    if (!updateActiveItem) {
      // Actualiza el valor de activeItem con el tamaño actualizado de dataEducations
      setActiveItem((parseInt(dataEducations.length) - 1).toString());
    }
  }, [dataEducations]);

  const handleSend = async () => {
    const resp = await postCandidateEducation(
      localStorage.getItem("candidateId"),
      dataEducations,
      dataKnowledges
    );
    if (resp.items.message === "Updated candidate " || resp.items.message === "Updated candidate") {
      Swal.fire({
        text: "El envío se ha efectuado con exito!.",
        icon: "success",
      });
      // hack for close accordeon
      setActiveItem("2000");
    } else {
      Swal.fire({
        text: "Ha habido un problema. Si el error persiste, comuníquese con soporte",
        icon: "error",
      });
    }
  };

  return (
    <>
      <div className="row mb-4 sideMenuSeparator align-items-center">
        <div className="col-2">
          <span className="title-icon p-2 m-auto">
            <FormacionIcon size={20} />
          </span>
        </div>
        <div className="col-10">
          <h1>{wheelCollaboratorTranslate.formation}</h1>
          <p className="description-section">{employeeExperienceTranslate.formationDesc}</p>
        </div>
      </div>
      <>
        {isLoading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            <div className="row mb-2 d-flex justify-content-end">
              <div style={{ maxWidth: "150px" }}>
                <button
                  className="btn rounded-pill addEmployeeInfo-btn"
                  onClick={() => handleAdd()}
                >
                  Add <AiOutlinePlusCircle size={25} />
                </button>
              </div>
            </div>
            <div className="row sideMenuSeparator px-2">
              {activeItem != null && (
                <EducationAccordion
                  itemActive={activeItem}
                  formations={dataEducations}
                  handleChange={handleChange}
                  handleSend={handleSend}
                />
              )}
            </div>
          </>
        )}
      </>
    </>
  );
};

export default InfoEducacion;
